import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import EmbeddedMapView from '../EmbeddedMapView';
import SeoMeta from '../SeoMeta';
import { PRIMARY_DEMO_ACCOUNT_ID } from '../../config/demoAccounts';
import './SolarMapPage.css';

const SolarMapPage: React.FC = () => {
  // Marker preview modals are rendered into <body> by Bootstrap and would otherwise
  // sit beneath the fixed .solar-map-strip header. The body class lets us shift the
  // modal-dialog down via CSS only when this page is mounted.
  useEffect(() => {
    document.body.classList.add('solar-map-active');
    return () => document.body.classList.remove('solar-map-active');
  }, []);

  return (
    <>
      <SeoMeta
        title="UK Solar Installations Map — Live Demo | Map of Projects"
        description="Every MCS-registered UK solar PV installation on one interactive map. Built in minutes with Map of Projects — make one for your own portfolio."
        path="/maps/solar-uk"
      />
      <div className="solar-map-strip">
        <div className="solar-map-strip__inner">
          <Link to="/" className="solar-map-strip__brand">
            <img src="/images/landing/default_logo.png" alt="" />
            <span>Map of Projects</span>
          </Link>
          <span className="solar-map-strip__title">
            UK Solar Installations — built in minutes
          </span>
          <Link
            to="/for/solar?source=demo-solar-uk"
            className="solar-map-strip__cta"
          >
            Make one for your portfolio →
          </Link>
        </div>
      </div>
      <EmbeddedMapView defaultClientId={PRIMARY_DEMO_ACCOUNT_ID} />
    </>
  );
};

export default SolarMapPage;
